import { render, staticRenderFns } from "./demand-feedback.vue?vue&type=template&id=41991b20&"
import script from "./demand-feedback.js?vue&type=script&lang=js&"
export * from "./demand-feedback.js?vue&type=script&lang=js&"
import style0 from "./demand-feedback.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports